import { MenuItem } from '@mui/material';


export function renderEnumOptions(options: { [key: string]: string }, includeAll?: boolean) {
    const entries = Object.entries(options);

    if (includeAll) {
        entries.unshift([ 'all', '-- All --' ]);
    }

    return entries.map(([ value, display ]) => (
        <MenuItem
            value={value}
            key={value}
        >
            {display}
        </MenuItem>
    )).filter(Boolean);
}
